import React, {ChangeEvent, MouseEvent, SetStateAction} from 'react'
import '../../CareersPage2024/careers-page-2024.css'
import axios from 'axios'
import {baseUrl} from '../../assets/Animations.js'
import { InstrumentChip } from '../../NewStudentForm/AutoFillNewStudentForm/InstrumentChip/InstrumentChip.js'
import { InputWithInsetLabel } from '../../DanitComponents/Inputs/InputWithInsetLabel.js'
import { MdSend } from 'react-icons/md'

const ManuallyEnterApplicationModal = ({setNewApplicationForm, setApplications}) => {
    const [school, setSchool] = React.useState('')
    const [schools, setSchools] = React.useState([])
    const [instruments, setInstruments] = React.useState([])
    const [playedInstruments, setPlayedInstruments] = React.useState([])
    const [teachingTowns, setTeachingTowns] = React.useState([])
    const [application, setApplication] = React.useState({
        key1app: '',
        key2app: '',
        key3app: '',
        key4app: '',
        key5app: '',
        key6app: '',
        key7app: false,
        key8app: '',
        key9app: '',
        key10app: '',
        key11app: '',
        key12app: '',
        key13app: [],
        key14app: '',
        key15app: '',
        key16app: '',
        key17app: false,
        key18app: false,
        key19app: false,
        key20app: '',
        key21app: false,
        key22app: '',
        id: Math.random().toString(16).slice(2),
      })
    const [submitting, setSubmitting] = React.useState(false)
    const [applicationSubmitted, setApplicationSubmitted] = React.useState(false)
    const myToken = localStorage.getItem('token')
    const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

    const standardInputs = [
        {label: 'First Name', placeholder: 'Your first name', value: application.key1app, func: (e) => setApplication((prev) => ({ ...prev, key1app: e.target.value}))},
        {label: 'Last Name', placeholder: 'Your last name', value: application.key2app, func: (e) => setApplication((prev) => ({ ...prev, key2app: e.target.value}))},
        {label: 'Email', placeholder: 'How can we reach you?', value: application.key3app, func: (e) => setApplication((prev) => ({ ...prev, key3app: e.target.value}))},
        {label: 'Phone', placeholder: 'Your phone number', value: application.key4app, func: (e) => setApplication((prev) => ({ ...prev, key4app: e.target.value}))},
        {label: 'City of residence', placeholder: 'Where do you live?', value: application.key5app, func: (e) => setApplication((prev) => ({ ...prev, key5app: e.target.value}))},
    ]

    React.useEffect(() => {
        axios.get(`${baseUrl}/schools`, myHeader)
        .then((res) => {
            setSchools(res.data)
        })
        .catch((err) => console.log(err))
        getInstruments()
    }, [])

    React.useEffect(() => {
        school !== '' && setApplication((prev) => ({ ...prev, key14app: school.name, key15app: school.email, key16app: `apply@${school.email.split('@')[1]}`}));
    }, [school])

    React.useEffect(() => {
        setApplication((prev) => ({ ...prev, key13app: playedInstruments}))
    }, [playedInstruments])

    React.useEffect(() => {
        let stringOfTownNames = teachingTowns.map((town) => town.name).join(' - ')
        setApplication((prev) => ({ ...prev, key22app: stringOfTownNames}))
    }, [teachingTowns])

    const getInstruments = () => {
        axios.get(`${baseUrl}/inst`)
        .then((res) => {
            let myList = res.data
            myList.sort(compareInstrumentNames)
            setInstruments(myList)
        })
        .catch((err) => console.log(err))
    }

    const compareInstrumentNames = (a, b) => {
        if ( a.name < b.name ) {return -1};
        if ( a.name > b.name ) {return 1};
        return 0;
    }

    const addInstrument = (id) => {
        for(let i = 0; i < instruments.length; i++) {
            if(instruments[i].id === id) {
                //check for duplicates
                for(let j = 0; j < playedInstruments.length; j++) {
                    if(playedInstruments[j].id === id) {
                        document.getElementById('careers-page-2024__select-with-label__actual-select').value = ''
                        return
                    }
                }
                setPlayedInstruments([...playedInstruments, instruments[i]])
            }
        }
        document.getElementById('careers-page-2024__select-with-label__actual-select').value = ''
    }

    const removeInstrument = (id) => {
        let newList = playedInstruments.filter((instrument) => instrument.id !== id)
        setPlayedInstruments(newList)
    }

    const addTown = (id) => {
        for(let i = 0; i < school.towns.length; i++) {
            if(school.towns[i].id === id) {
                //check for duplicates
                for(let j = 0; j < teachingTowns.length; j++) {
                    if(teachingTowns[j].id === id) {
                        document.getElementById('careers-page-2024__select-with-label__actual-select__towns').value = ''
                        return
                    }
                }
                setTeachingTowns([...teachingTowns, school.towns[i]])
            }
        }
        document.getElementById('careers-page-2024__select-with-label__actual-select__towns').value = ''
    }

    const removeTown = (id) => {
        let newList = teachingTowns.filter((town) => town.id !== id)
        setTeachingTowns(newList)
    }

    const submitApplication = () => {
        setSubmitting(true)
        axios.put(`${baseUrl}/new-manual-teacherapplication`, {
            application: application
        })
        .then(response => {
            if(response.status === 201) {
                setApplications((prev) => ([...prev, application]))
                setSubmitting(false)
                setApplicationSubmitted(true)
                setNewApplicationForm(false)
            } else {
                alert('Sorry! There seems to be a problem. Try submitting your application again.')
            }
        })
        .catch(e => {
            console.log('Oops ' + e)
            console.log(e)
        })
    }

    const closeModal = (id) => {
        if(id === 'jobs-page-modal-wrapper') {
            setNewApplicationForm(false)
        }
    }

    const selectASchool = (id) => {
        for(let i = 0; i < schools.length; i++) {
            if(schools[i].id === id) {
                setSchool(schools[i])
            }
        }
    }


    return (
        <div 
        className="manually-enter-application-modal__wrapper" 
        id="jobs-page-modal-wrapper" 
        onClick={(e) => {
          if (e.target) {
            closeModal(e.target.id);
          }
        }}
    >
        <div className="manually-enter-jobs-page-application-modal">
        <div className='careers-page-2024__8-section' id="careers-page-2024__8-section">
                        <div className='careers-page-2024__8-section__title'>Application for {school.name}</div>
                        <div>
                                <select onChange={(e) => selectASchool(e.target.value) }>
                                    <option value="">Select a school</option>
                                    {schools.map((school) => (
                                        <option key={school.id} value={school.id}>{school.name}</option>
                                    ))}
                                </select>
                            </div>
                        <div className='careers-page-2024__8-section__application-form__wrapper__manually'>

                            {standardInputs.map((input, index) => {
                                return (
                                    <div key={index} className='careers-page-2024__input-wrapper'>
                                        <InputWithInsetLabel label={input.label} placeholder={input.placeholder} value={input.value} changeFunction={input.func} />
                                    </div>
                                )
                            })}
                            <div className='careers-page-2024__input-wrapper'>
                                <div className='careers-page-2024__dropdown-label'>Ideal Studio Size</div>
                                <select className='careers-page-2024__select-with-label__actual-select' name="selectInput2" value={application.key9app} onChange={(e) => setApplication((prev) => ({...prev, key9app: e.target.value}))} >
                                    <option value="">How many students are you dreaming of?</option>
                                        <option value='1-5'>1-5 Students</option>
                                        <option value='5-10'>5-10 Students</option>
                                        <option value='10-15'>10-15 Students</option>
                                        <option value='15-20'>15-20 Students</option>
                                        <option value='20-25'>20-25 Students</option>
                                </select>
                            </div>
                            <div className='careers-page-2024__input-wrapper'>
                                <div className='careers-page-2024__dropdown-label'>Experience Level</div>
                                <select className='careers-page-2024__select-with-label__actual-select' name="selectInput2" value={application.key6app} onChange={(e) => setApplication((prev) => ({...prev, key6app: e.target.value}))}>
                                    <option value="">How many years have you been teaching?</option>
                                    <option value='1'>1 years</option>
                                    <option value='2'>2 years</option>
                                    <option value='3'>3 years</option>
                                    <option value='4'>4 years</option>
                                    <option value='+5'>+5 years</option>
                                </select>
                            </div>
                            <div className='careers-page-2024__input-wrapper'>
                                <div className='careers-page-2024__dropdown-label'>Instrument(s)</div>
                                <select className='careers-page-2024__select-with-label__actual-select' id='careers-page-2024__select-with-label__actual-select' name="selectInput1" onChange={(e) => addInstrument(e.target.value)} >
                                    <option value="">{playedInstruments?.length > 0 ? 'Add another instrument' : 'Choose an instrument'}</option>
                                    {instruments.map((instrument) => (
                                        <option key={instrument.id} value={instrument.id}>{instrument.name}</option>
                                    ))}
                                </select>
                                {playedInstruments?.length > 0 ? (
                                    <div>
                                        {playedInstruments?.map((instrument) => (
                                            <InstrumentChip key={instrument.id} instrument={instrument} onClick={() => removeInstrument(instrument.id)} />
                                        ))}
                                    </div>
                                )
                                :
                                    <p className='auto-fill-new-student-form__page__each-input__error-message'>Please select an instrument</p>
                                }
                            </div>
                            <div className='careers-page-2024__input-wrapper'>
                            <div className='careers-page-2024__dropdown-label'>Areas You Are Willing to Service</div>
                                {school && 
                                    <select className='careers-page-2024__select-with-label__actual-select' id='careers-page-2024__select-with-label__actual-select__towns' name="selectInput1" onChange={(e) => addTown(e.target.value)} >
                                        <option value="">{teachingTowns?.length > 0 ? 'Add another town' : 'Add a town'}</option>
                                        {school.towns.map((town) => (
                                            <option key={town.id} value={town.id}>{town.name}</option>
                                        ))}
                                    </select>
                                }
                                {teachingTowns?.length > 0 ? (
                                    <div>
                                        {teachingTowns?.map((town) => (
                                            <InstrumentChip key={town.id} instrument={town} onClick={() => removeTown(town.id)} />
                                        ))}
                                    </div>
                                )
                                :
                                    <p className='auto-fill-new-student-form__page__each-input__error-message'>Please select an location</p>
                                }
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>COVER LETTER</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Why are you a great fit for our school?' value={application.key10app} onChange={(e) => {setApplication((prev) => ({ ...prev, key10app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>EDUCATION</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Please list your education: Institutions, Degrees, and graduation dates (you can include education that is in-progress)' value={application.key11app} onChange={(e) => {setApplication((prev) => ({ ...prev, key11app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>LINKS</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Links to video or audio recordings of you playing' value={application.key20app} onChange={(e) => {setApplication((prev) => ({ ...prev, key20app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>WHAT MAKES YOU INTERESTED IN WORKING FOR US?</div>
                                <textarea className='careers-page-2024__text-field' placeholder='Why do you want to work with us' value={application.key12app} onChange={(e) => {setApplication((prev) => ({ ...prev, key12app: e.target.value})); }}></textarea>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key7app: !prev.key7app}))}>
                                {application.key7app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='../../right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='../../right-empty.svg' /> }
                                    <strong className='careers-page-2024__checkmark-title'>I have experience providing in-home lessons</strong>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key17app: !prev.key17app}))}>
                                {application.key17app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='../../right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='../../right-empty.svg' /> }
                                    <strong className='careers-page-2024__checkmark-title'>I am willing to undergo a background check, in accordance with local law/regulations.</strong>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key18app: !prev.key18app}))}>
                                {application.key18app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='../../right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='../../right-empty.svg' /> }
                                <strong className='careers-page-2024__checkmark-title'>I have a reliable vehicle.</strong>
                            </div>
                            <div className='careers-page-2024__check-wrapper' onClick={() => setApplication((prev) => ({...prev, key19app: !prev.key19app}))}>
                                {application.key19app ? <img alt='checkmark' className='careers-page-2024__checkmark' style={{backgroundColor: 'rgb(19, 174, 92)', borderRadius: '50%'}} src='../../right.svg'/> : <img alt='empty-box' className='careers-page-2024__checkmark' src='../../right-empty.svg' /> }
                                <strong className='careers-page-2024__checkmark-title'>I have a valid driver’s license.</strong>
                            </div>
                            <div className='careers-page-2024__text-field-wrapper'>
                                <div className='careers-page-2024__text-field-label'>WHERE DID YOU HEAR ABOUT US?</div>
                                <textarea className='careers-page-2024__text-field' onChange={(e) => setApplication((prev) => ({...prev, key21app: e.target.value}))} placeholder='How did you find us'></textarea>
                            </div>
                        </div>
                        {applicationSubmitted ? 
                            <div className='careers-page-2024__final-apply-button__wrapper'>
                                <div style={{color: 'green'}}>Application Received!</div>
                            </div>    
                        :
                        <div className='careers-page-2024__final-apply-button__wrapper'>
                            {submitting ? 
                                <div className='careers-page-2024__apply-now-button__loading'>Submitting Application...</div>
                            :
                            <div className='careers-page-2024__apply-now-button'>
                                <div className='careers-page-2024__apply-now-button__text' onClick={() => submitApplication()}>Submit Application</div>
                                <MdSend size={18} />
                            </div>
                            }
                        </div>
                        }
                    </div>
        </div>
    </div>
    )
}
export default ManuallyEnterApplicationModal;